"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _InstallStatusConstants = require("ui-addon-scriptloader/installStatus/InstallStatusConstants");

var _atom = require("atom");

var InstallStatusStoreAtom = (0, _atom.atom)(_InstallStatusConstants.NOT_INITIALIZED); // this proxy makes InstallStatusStore easier to test.

var InstallStatusStore = {
  get: function get() {
    return (0, _atom.deref)(InstallStatusStoreAtom);
  },
  set: function set(value) {
    return (0, _atom.swap)(InstallStatusStoreAtom, function () {
      return value;
    });
  },
  subscribe: function subscribe(callback) {
    return (0, _atom.watch)(InstallStatusStoreAtom, callback);
  },
  unsubscribe: function unsubscribe(callback) {
    return (0, _atom.unwatch)(InstallStatusStoreAtom, callback);
  }
};
var _default = InstallStatusStore;
exports.default = _default;
module.exports = exports.default;